export default class Kunde {

    Vorname: string = '';
    Nachname: string = '';
    Strasse: string = '';
    Hausnummer: string = '';
    PLZ: string = '';
    Ort: string = '';
    EMailAdresse: string = '';
    Telefonnummer: string = '';
    agbChecked: boolean = false;
    dsChecked: boolean = false;

    constructor() {
    }

    validate() {
        const invalid = [];
        if (!this.validateMinLength()) invalid.push("Nachname");
        if (!this.validateMail()) invalid.push("Mail");
        if (!this.validateCheckboxesChecked()) invalid.push("Datenschutz");
        return invalid;
    }

    validateMinLength(){
        return this.Nachname.length >= 1;
    }

    validatePhone() {
        return /\d+/.test(this.Telefonnummer)
    }

    validateCheckboxesChecked() {
        return this.dsChecked;
    }

    validateMail() {
        return this.EMailAdresse.indexOf("@") > 0
            && this.EMailAdresse.length >= 3;
    }

    fromJson(json) {
        this.Vorname = json.Vorname || '';
        this.Nachname = json.Nachname || '';
        this.Strasse = json.Strasse || '';
        this.Hausnummer = json.Hausnummer || '';
        this.PLZ = json.PLZ || '';
        this.Ort = json.Ort || '';
        this.EMailAdresse = json.EMailAdresse || '';
        this.Telefonnummer = json.Telefonnummer || '';
        return this;
    }

    toJson() {
        return {
            Vorname: this.Vorname,
            Nachname: this.Nachname,
            Strasse: this.Strasse,
            Hausnummer: this.Hausnummer,
            PLZ: this.PLZ,
            Ort: this.Ort,
            EMailAdresse: this.EMailAdresse,
            Telefonnummer: this.Telefonnummer,
            agbChecked: this.agbChecked,
            dsChecked: this.dsChecked,
        }
    }

    iterate(iterator) {
        iterator(this);
    }

}